exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n.authdialog div[class^=\"MuiPaper-root\"] {\r\n  overflow: hidden;\r\n}\r\n", ""]);

// exports
